import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import AuthLayout from '../../components/AuthLayout';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(email, password);
    // POS-First: Redirect to POS (protected route) after login
    if (success) navigate('/pos');
    setLoading(false);
  };

  return (
    <AuthLayout 
      title={t('auth.welcomeBack')} 
      subtitle={t('auth.enterCredentials')} 
      type="login"
    >
      <form onSubmit={handleLogin} className="space-y-4">
        <div className="space-y-2">
          <label className={`text-sm font-medium ${isRTL ? 'block text-right' : ''}`}>{t('auth.email')}</label>
          <Input 
            type="email" 
            placeholder={t('auth.emailPlaceholder')}
            required 
            className={`h-11 ${isRTL ? 'text-right' : ''}`}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="space-y-2">
          <div className={`flex items-center justify-between ${isRTL ? 'flex-row-reverse' : ''}`}>
            <label className="text-sm font-medium">{t('auth.password')}</label>
            <Link to="#" className="text-sm text-primary hover:underline">{t('auth.forgotPassword')}</Link>
          </div>
          <Input 
            type="password" 
            placeholder={t('auth.passwordPlaceholder')}
            required 
            className={`h-11 ${isRTL ? 'text-right' : ''}`}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <Button type="submit" className="w-full h-11 text-base" disabled={loading}>
            {loading ? t('auth.signingIn') : t('auth.signIn')}
        </Button>
      </form>
    </AuthLayout>
  );
};

export default Login;
